import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["field", "warning", "trigger"];

  unlock() {
    this.fieldTarget.removeAttribute("readonly");
    this.fieldTarget.classList.remove("bg-gray-50", "cursor-not-allowed");
    this.fieldTarget.focus();
    if (this.hasWarningTarget) this.warningTarget.classList.remove("hidden");
    this.triggerTarget.classList.add("hidden");
  }
}
